/*!
 * Copyright (c) 2017 BAMTech, LLC an MLB Advanced Media company.
 * 
 * All use of this software development kit ("SDK") is subject to the
 * applicable licensing terms between BAMTech, LLC ("BAMTech") and its
 * authorized licensees. Any use in violation of such licensing terms
 * shall result in revocation of access to the SDK in addition to any
 * rights and remedies of BAMTech available pursuant to the applicable SDK
 * license.
 * 
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bam-browser-sdk"));
	else if(typeof define === 'function' && define.amd)
		define(["bam-browser-sdk"], factory);
	else if(typeof exports === 'object')
		exports["bam-browser-sdk-sdkSession-util"] = factory(require("bam-browser-sdk"));
	else
		root["bam-browser-sdk-sdkSession-util"] = factory(root["bam-browser-sdk"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module entry
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @description
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _checkTypes = __webpack_require__(3);
	
	var _checkTypes2 = _interopRequireDefault(_checkTypes);
	
	var _bamBrowserSdk = __webpack_require__(1);
	
	var _bamBrowserSdk2 = _interopRequireDefault(_bamBrowserSdk);
	
	var _events = __webpack_require__(4);
	
	var _geoProviderMock = __webpack_require__(2);
	
	var _geoProviderMock2 = _interopRequireDefault(_geoProviderMock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SdkSession = _bamBrowserSdk2.default.SdkSession;
	var BootstrapConfiguration = _bamBrowserSdk2.default.Services.Configuration.BootstrapConfiguration;
	
	/**
	 *
	 * @access private
	 * @type {EventEmitter}
	 *
	 */
	var eventEmitter = new _events.EventEmitter();
	
	/**
	 *
	 * @access private
	 * @type {SDK.Services.Configuration.BootstrapConfiguration}
	 *
	 */
	var bootstrapConfiguration = void 0;
	
	/**
	 *
	 * @access private
	 * @type {Promise}
	 *
	 */
	var sdkSessionPromise = void 0;
	
	/**
	 *
	 * @access private
	 * @type {SDK.Token.GeoProvider}
	 *
	 */
	var geoProvider = void 0;
	
	/**
	 *
	 * @class SdkSessionUtil
	 * @description Singleton model to get a shared instance of a SDK.SdkSession
	 *
	 */
	
	var SdkSessionUtil = function () {
	    function SdkSessionUtil() {
	        _classCallCheck(this, SdkSessionUtil);
	    }
	
	    _createClass(SdkSessionUtil, null, [{
	        key: 'setBootstrapConfiguration',
	
	
	        /**
	         *
	         * @access public
	         * SdkSessionUtil.getSdkSession()
	         * @param {Object} config
	         * @desc Set up the bootstrap configuration for the SDK. Must be called before
	         *
	         */
	        value: function setBootstrapConfiguration(config) {
	            var mockGeoLocation = config.mockGeoLocation;
	
	
	            if (mockGeoLocation) {
	                var latitude = mockGeoLocation.latitude,
	                    longitude = mockGeoLocation.longitude;
	
	
	                geoProvider = new _geoProviderMock2.default(latitude, longitude);
	            }
	
	            /** Set up bootstrap configuration */
	            bootstrapConfiguration = new BootstrapConfiguration(config);
	        }
	
	        /**
	         *
	         * @access public
	         * @returns {Promise<SDK.SdkSession>}
	         *
	         */
	
	    }, {
	        key: 'getSdkSession',
	        value: function getSdkSession() {
	
	            /** Resolve the previously created sdkSession, if exists */
	            if (_checkTypes2.default.assigned(sdkSessionPromise)) {
	
	                return sdkSessionPromise;
	            }
	
	            var method = 'SdkSessionUtil.getSdkSession()';
	            var bootstrapConfigurationError = method + ' needs BootstrapConfiguration instance.\n            Call SdkSessionUtil.setBootstrapConfiguration(config) first.';
	
	            _checkTypes2.default.assert.instanceStrict(bootstrapConfiguration, BootstrapConfiguration, bootstrapConfigurationError);
	
	            var sdkSession = void 0;
	
	            /** Create a SDK.SdkSession and initialize it */
	            sdkSessionPromise = SdkSession.createSdkSession(bootstrapConfiguration, geoProvider).then(function (session) {
	
	                sdkSession = session;
	
	                return sdkSession.initialize().catch(function () {
	
	                    return sdkSession.reset().then(function () {
	
	                        eventEmitter.emit('SdkSessionResetOnError');
	
	                        return Promise.resolve();
	                    });
	                });
	            }).then(function () {
	
	                return Promise.resolve(sdkSession);
	            });
	
	            return sdkSessionPromise;
	        }
	
	        /**
	         *
	         * @access public
	         * @param {String} event
	         * @param {Function} handler
	         *
	         */
	
	    }, {
	        key: 'on',
	        value: function on(event, handler) {
	
	            eventEmitter.on(event, handler);
	        }
	
	        /**
	         *
	         * @access public
	         * @param {String} [event]
	         * @param {Function} [handler]
	         * @desc If called with no parameters, it will remove all listeners. Passing only event, it will remove
	         * all listeners for that event.
	         *
	         */
	
	    }, {
	        key: 'off',
	        value: function off(event, handler) {
	
	            if (_checkTypes2.default.not.assigned(handler)) {
	                eventEmitter.removeAllListeners(event);
	            }
	
	            eventEmitter.removeListener(event, handler);
	        }
	    }]);
	
	    return SdkSessionUtil;
	}();
	
	/** Unique key for referencing the SdkSessionUtil in the global scope */
	
	
	var SDK_SESSION_UTIL_KEY = Symbol.for('BAM.SDK.SdkSessionUtil');
	
	/** npm:window-or-global */
	var scope = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) === 'object' && self.self === self && self || (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global.global === global && global || window;
	
	/** Get the scope's symbols */
	var scopeSymbols = Object.getOwnPropertySymbols(scope);
	
	/** Check the scope for existing symbol  */
	if (scopeSymbols.indexOf(SDK_SESSION_UTIL_KEY) === -1) {
	
	    scope[SDK_SESSION_UTIL_KEY] = SdkSessionUtil;
	}
	
	/** Singleton API */
	
	var API = function () {
	    function API() {
	        _classCallCheck(this, API);
	    }
	
	    _createClass(API, null, [{
	        key: 'instance',
	
	
	        /**
	         *
	         * @returns {SdkSessionUtil}
	         *
	         */
	        get: function get() {
	
	            return scope[SDK_SESSION_UTIL_KEY];
	        }
	    }]);
	
	    return API;
	}();
	
	/** Lock the API */
	
	
	Object.freeze(API);
	
	/** Export the singleton */
	exports.default = API.instance;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _bamBrowserSdk = __webpack_require__(1);
	
	var _bamBrowserSdk2 = _interopRequireDefault(_bamBrowserSdk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 *
	 * @class GeoProviderMock
	 * @description A mock GeoProvider to pass to SDK.SdkSession.createSdkSession
	 * @see https://github.bamtech.co/fed-core/browser-sdk/blob/master/docs/services/GeoProvider.md
	 * @see https://github.bamtech.co/fed-core/browser-sdk/blob/master/docs/usage/Examples.md#create-sdksession
	 * @see https://github.bamtech.co/sdk-doc/spec-sdk/blob/master/specs/features/sdkSession.md#createsdksession
	 *
	 */
	var GeoProviderMock = function (_SDK$Token$GeoProvide) {
	  _inherits(GeoProviderMock, _SDK$Token$GeoProvide);
	
	  /**
	   *
	   * @param {Number} [latitude=0]
	   * @param {Number} [longitude=0]
	   *
	   */
	  function GeoProviderMock() {
	    var latitude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var longitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    _classCallCheck(this, GeoProviderMock);
	
	    /**
	     *
	     * @access public
	     * @type {Number}
	     * @desc The latitude of the location.
	     *
	     */
	    var _this = _possibleConstructorReturn(this, (GeoProviderMock.__proto__ || Object.getPrototypeOf(GeoProviderMock)).call(this));
	
	    _this.latitude = latitude;
	
	    /**
	     *
	     * @access public
	     * @type {Number}
	     * @desc The longitude of the location.
	     *
	     */
	    _this.longitude = longitude;
	
	    return _this;
	  }
	
	  /**
	   *
	   * @access public
	   * @desc Retrieves the current GeoLocation of the device.
	   * @returns {Promise<GeoLocation>}
	   *
	   */
	
	
	  _createClass(GeoProviderMock, [{
	    key: 'getGeoLocation',
	    value: function getGeoLocation() {
	      var latitude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.latitude;
	      var longitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.longitude;
	
	
	      return Promise.resolve({
	        latitude: latitude,
	        longitude: longitude
	      });
	    }
	  }]);
	
	  return GeoProviderMock;
	}(_bamBrowserSdk2.default.Token.GeoProvider);
	
	exports.default = GeoProviderMock;
	module.exports = exports['default'];

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*globals define, module, Symbol */
	/*jshint -W056 */
	
	(function (globals) {
	  'use strict';
	
	  var strings, messages, predicates, functions, assert, not, maybe,
	      collections, slice, neginf, posinf, isArray, haveSymbols;
	
	  strings = {
	    v: 'value',
	    n: 'number',
	    s: 'string',
	    b: 'boolean',
	    o: 'object',
	    t: 'type',
	    a: 'array',
	    al: 'array-like',
	    i: 'iterable',
	    d: 'date',
	    f: 'function',
	    l: 'length'
	  };
	
	  messages = {};
	  predicates = {};
	
	  [
	    { n: 'equal', f: equal, s: 'v' },
	    { n: 'undefined', f: isUndefined, s: 'v' },
	    { n: 'null', f: isNull, s: 'v' },
	    { n: 'assigned', f: assigned, s: 'v' },
	    { n: 'primitive', f: primitive, s: 'v' },
	    { n: 'includes', f: includes, s: 'v' },
	    { n: 'zero', f: zero },
	    { n: 'infinity', f: infinity },
	    { n: 'number', f: number },
	    { n: 'integer', f: integer },
	    { n: 'even', f: even },
	    { n: 'odd', f: odd },
	    { n: 'greater', f: greater },
	    { n: 'less', f: less },
	    { n: 'between', f: between },
	    { n: 'greaterOrEqual', f: greaterOrEqual },
	    { n: 'lessOrEqual', f: lessOrEqual },
	    { n: 'inRange', f: inRange },
	    { n: 'positive', f: positive },
	    { n: 'negative', f: negative },
	    { n: 'string', f: string, s: 's' },
	    { n: 'emptyString', f: emptyString, s: 's' },
	    { n: 'nonEmptyString', f: nonEmptyString, s: 's' },
	    { n: 'contains', f: contains, s: 's' },
	    { n: 'match', f: match, s: 's' },
	    { n: 'boolean', f: boolean, s: 'b' },
	    { n: 'object', f: object, s: 'o' },
	    { n: 'emptyObject', f: emptyObject, s: 'o' },
	    { n: 'nonEmptyObject', f: nonEmptyObject, s: 'o' },
	    { n: 'instanceStrict', f: instanceStrict, s: 't' },
	    { n: 'instance', f: instance, s: 't' },
	    { n: 'like', f: like, s: 't' },
	    { n: 'array', f: array, s: 'a' },
	    { n: 'emptyArray', f: emptyArray, s: 'a' },
	    { n: 'nonEmptyArray', f: nonEmptyArray, s: 'a' },
	    { n: 'arrayLike', f: arrayLike, s: 'al' },
	    { n: 'iterable', f: iterable, s: 'i' },
	    { n: 'date', f: date, s: 'd' },
	    { n: 'function', f: isFunction, s: 'f' },
	    { n: 'hasLength', f: hasLength, s: 'l' },
	  ].map(function (data) {
	    var n = data.n;
	    messages[n] = 'Invalid ' + strings[data.s || 'n'];
	    predicates[n] = data.f;
	  });
	
	  functions = {
	    apply: apply,
	    map: map,
	    all: all,
	    any: any
	  };
	
	  collections = [ 'array', 'arrayLike', 'iterable', 'object' ];
	  slice = Array.prototype.slice;
	  neginf = Number.NEGATIVE_INFINITY;
	  posinf = Number.POSITIVE_INFINITY;
	  isArray = Array.isArray;
	  haveSymbols = typeof Symbol === 'function';
	
	  functions = mixin(functions, predicates);
	  assert = createModifiedPredicates(assertModifier, assertImpl);
	  not = createModifiedPredicates(notModifier, notImpl);
	  maybe = createModifiedPredicates(maybeModifier, maybeImpl);
	  assert.not = createModifiedModifier(assertModifier, not);
	  assert.maybe = createModifiedModifier(assertModifier, maybe);
	
	  collections.forEach(createOfPredicates);
	  createOfModifiers(assert, assertModifier);
	  createOfModifiers(not, notModifier);
	  collections.forEach(createMaybeOfModifiers);
	
	  exportFunctions(mixin(functions, {
	    assert: assert,
	    not: not,
	    maybe: maybe
	  }));
	
	  /**
	   * Public function `equal`.
	   *
	   * Returns true if `lhs` and `rhs` are strictly equal, without coercion.
	   * Returns false otherwise.
	   */
	  function equal (lhs, rhs) {
	    return lhs === rhs;
	  }
	
	  /**
	   * Public function `undefined`.
	   *
	   * Returns true if `data` is undefined, false otherwise.
	   */
	  function isUndefined (data) {
	    return data === undefined;
	  }
	
	  /**
	   * Public function `null`.
	   *
	   * Returns true if `data` is null, false otherwise.
	   */
	  function isNull (data) {
	    return data === null;
	  }
	
	  /**
	   * Public function `assigned`.
	   *
	   * Returns true if `data` is not null or undefined, false otherwise.
	   */
	  function assigned (data) {
	    return data !== undefined && data !== null;
	  }
	
	  /**
	   * Public function `primitive`.
	   *
	   * Returns true if `data` is a primitive type, false otherwise.
	   */
	  function primitive (data) {
	    var type;
	
	    switch (data) {
	      case null:
	      case undefined:
	      case false:
	      case true:
	        return true;
	    }
	
	    type = typeof data;
	    return type === 'string' || type === 'number' || (haveSymbols && type === 'symbol');
	  }
	
	  /**
	   * Public function `zero`.
	   *
	   * Returns true if `data` is zero, false otherwise.
	   */
	  function zero (data) {
	    return data === 0;
	  }
	
	  /**
	   * Public function `infinity`.
	   *
	   * Returns true if `data` is positive or negative infinity, false otherwise.
	   */
	  function infinity (data) {
	    return data === neginf || data === posinf;
	  }
	
	  /**
	   * Public function `number`.
	   *
	   * Returns true if `data` is a number, false otherwise.
	   */
	  function number (data) {
	    return typeof data === 'number' && data > neginf && data < posinf;
	  }
	
	  /**
	   * Public function `integer`.
	   *
	   * Returns true if `data` is an integer, false otherwise.
	   */
	  function integer (data) {
	    return typeof data === 'number' && data % 1 === 0;
	  }
	
	  /**
	   * Public function `even`.
	   *
	   * Returns true if `data` is an even number, false otherwise.
	   */
	  function even (data) {
	    return typeof data === 'number' && data % 2 === 0;
	  }
	
	  /**
	   * Public function `odd`.
	   *
	   * Returns true if `data` is an odd number, false otherwise.
	   */
	  function odd (data) {
	    return integer(data) && data % 2 !== 0;
	  }
	
	  /**
	   * Public function `greater`.
	   *
	   * Returns true if `lhs` is a number greater than `rhs`, false otherwise.
	   */
	  function greater (lhs, rhs) {
	    return number(lhs) && lhs > rhs;
	  }
	
	  /**
	   * Public function `less`.
	   *
	   * Returns true if `lhs` is a number less than `rhs`, false otherwise.
	   */
	  function less (lhs, rhs) {
	    return number(lhs) && lhs < rhs;
	  }
	
	  /**
	   * Public function `between`.
	   *
	   * Returns true if `data` is a number between `x` and `y`, false otherwise.
	   */
	  function between (data, x, y) {
	    if (x < y) {
	      return greater(data, x) && data < y;
	    }
	
	    return less(data, x) && data > y;
	  }
	
	  /**
	   * Public function `greaterOrEqual`.
	   *
	   * Returns true if `lhs` is a number greater than or equal to `rhs`, false
	   * otherwise.
	   */
	  function greaterOrEqual (lhs, rhs) {
	    return number(lhs) && lhs >= rhs;
	  }
	
	  /**
	   * Public function `lessOrEqual`.
	   *
	   * Returns true if `lhs` is a number less than or equal to `rhs`, false
	   * otherwise.
	   */
	  function lessOrEqual (lhs, rhs) {
	    return number(lhs) && lhs <= rhs;
	  }
	
	  /**
	   * Public function `inRange`.
	   *
	   * Returns true if `data` is a number in the range `x..y`, false otherwise.
	   */
	  function inRange (data, x, y) {
	    if (x < y) {
	      return greaterOrEqual(data, x) && data <= y;
	    }
	
	    return lessOrEqual(data, x) && data >= y;
	  }
	
	  /**
	   * Public function `positive`.
	   *
	   * Returns true if `data` is a positive number, false otherwise.
	   */
	  function positive (data) {
	    return greater(data, 0);
	  }
	
	  /**
	   * Public function `negative`.
	   *
	   * Returns true if `data` is a negative number, false otherwise.
	   */
	  function negative (data) {
	    return less(data, 0);
	  }
	
	  /**
	   * Public function `string`.
	   *
	   * Returns true if `data` is a string, false otherwise.
	   */
	  function string (data) {
	    return typeof data === 'string';
	  }
	
	  /**
	   * Public function `emptyString`.
	   *
	   * Returns true if `data` is the empty string, false otherwise.
	   */
	  function emptyString (data) {
	    return data === '';
	  }
	
	  /**
	   * Public function `nonEmptyString`.
	   *
	   * Returns true if `data` is a non-empty string, false otherwise.
	   */
	  function nonEmptyString (data) {
	    return string(data) && data !== '';
	  }
	
	  /**
	   * Public function `contains`.
	   *
	   * Returns true if `data` is a string that contains `substring`, false
	   * otherwise.
	   */
	  function contains (data, substring) {
	    return string(data) && data.indexOf(substring) !== -1;
	  }
	
	  /**
	   * Public function `match`.
	   *
	   * Returns true if `data` is a string that matches `regex`, false otherwise.
	   */
	  function match (data, regex) {
	    return string(data) && !! data.match(regex);
	  }
	
	  /**
	   * Public function `boolean`.
	   *
	   * Returns true if `data` is a boolean value, false otherwise.
	   */
	  function boolean (data) {
	    return data === false || data === true;
	  }
	
	  /**
	   * Public function `object`.
	   *
	   * Returns true if `data` is a plain-old JS object, false otherwise.
	   */
	  function object (data) {
	    return Object.prototype.toString.call(data) === '[object Object]';
	  }
	
	  /**
	   * Public function `emptyObject`.
	   *
	   * Returns true if `data` is an empty object, false otherwise.
	   */
	  function emptyObject (data) {
	    return object(data) && Object.keys(data).length === 0;
	  }
	
	  /**
	   * Public function `nonEmptyObject`.
	   *
	   * Returns true if `data` is a non-empty object, false otherwise.
	   */
	  function nonEmptyObject (data) {
	    return object(data) && Object.keys(data).length > 0;
	  }
	
	  /**
	   * Public function `instanceStrict`.
	   *
	   * Returns true if `data` is an instance of `prototype`, false otherwise.
	   */
	  function instanceStrict (data, prototype) {
	    try {
	      return data instanceof prototype;
	    } catch (error) {
	      return false;
	    }
	  }
	
	  /**
	   * Public function `instance`.
	   *
	   * Returns true if `data` is an instance of `prototype`, false otherwise.
	   * Falls back to testing constructor.name and Object.prototype.toString
	   * if the initial instanceof test fails.
	   */
	  function instance (data, prototype) {
	    try {
	      return instanceStrict(data, prototype) ||
	        data.constructor.name === prototype.name ||
	        Object.prototype.toString.call(data) === '[object ' + prototype.name + ']';
	    } catch (error) {
	      return false;
	    }
	  }
	
	  /**
	   * Public function `like`.
	   *
	   * Tests whether `data` 'quacks like a duck'. Returns true if `data` has all
	   * of the properties of `archetype` (the 'duck'), false otherwise.
	   */
	  function like (data, archetype) {
	    var name;
	
	    for (name in archetype) {
	      if (archetype.hasOwnProperty(name)) {
	        if (data.hasOwnProperty(name) === false || typeof data[name] !== typeof archetype[name]) {
	          return false;
	        }
	
	        if (object(data[name]) && like(data[name], archetype[name]) === false) {
	          return false;
	        }
	      }
	    }
	
	    return true;
	  }
	
	  /**
	   * Public function `array`.
	   *
	   * Returns true if `data` is an array, false otherwise.
	   */
	  function array (data) {
	    return isArray(data);
	  }
	
	  /**
	   * Public function `emptyArray`.
	   *
	   * Returns true if `data` is an empty array, false otherwise.
	   */
	  function emptyArray (data) {
	    return array(data) && data.length === 0;
	  }
	
	  /**
	   * Public function `nonEmptyArray`.
	   *
	   * Returns true if `data` is a non-empty array, false otherwise.
	   */
	  function nonEmptyArray (data) {
	    return array(data) && greater(data.length, 0);
	  }
	
	  /**
	   * Public function `arrayLike`.
	   *
	   * Returns true if `data` is an array-like object, false otherwise.
	   */
	  function arrayLike (data) {
	    return assigned(data) && greaterOrEqual(data.length, 0);
	  }
	
	  /**
	   * Public function `iterable`.
	   *
	   * Returns true if `data` is an iterable, false otherwise.
	   */
	  function iterable (data) {
	    if (! haveSymbols) {
	      // Fall back to `arrayLike` predicate in pre-ES6 environments.
	      return arrayLike(data);
	    }
	
	    return assigned(data) && isFunction(data[Symbol.iterator]);
	  }
	
	  /**
	   * Public function `includes`.
	   *
	   * Returns true if `data` contains `value`, false otherwise.
	   */
	  function includes (data, value) {
	    var iterator, iteration, keys, length, i;
	
	    if (! assigned(data)) {
	      return false;
	    }
	
	    if (haveSymbols && data[Symbol.iterator] && isFunction(data.values)) {
	      iterator = data.values();
	
	      do {
	        iteration = iterator.next();
	
	        if (iteration.value === value) {
	          return true;
	        }
	      } while (! iteration.done);
	
	      return false;
	    }
	
	    keys = Object.keys(data);
	    length = keys.length;
	    for (i = 0; i < length; ++i) {
	      if (data[keys[i]] === value) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  /**
	   * Public function `hasLength`.
	   *
	   * Returns true if `data` has a length property that equals `length`, false
	   * otherwise.
	   */
	  function hasLength (data, length) {
	    return assigned(data) && data.length === length;
	  }
	
	  /**
	   * Public function `date`.
	   *
	   * Returns true if `data` is a valid date, false otherwise.
	   */
	  function date (data) {
	    return instanceStrict(data, Date) && integer(data.getTime());
	  }
	
	  /**
	   * Public function `function`.
	   *
	   * Returns true if `data` is a function, false otherwise.
	   */
	  function isFunction (data) {
	    return typeof data === 'function';
	  }
	
	  /**
	   * Public function `apply`.
	   *
	   * Maps each value from the `data` to the corresponding predicate and returns
	   * the result array. If the same function is to be applied across all of the
	   * data, a single predicate function may be passed in.
	   *
	   */
	  function apply (data, predicates) {
	    assert.array(data);
	
	    if (isFunction(predicates)) {
	      return data.map(function (value) {
	        return predicates(value);
	      });
	    }
	
	    assert.array(predicates);
	    assert.hasLength(data, predicates.length);
	
	    return data.map(function (value, index) {
	      return predicates[index](value);
	    });
	  }
	
	  /**
	   * Public function `map`.
	   *
	   * Maps each value from the `data` to the corresponding predicate and returns
	   * the result object. Supports nested objects. If the `data` is not nested and
	   * the same function is to be applied across all of it, a single predicate
	   * function may be passed in.
	   *
	   */
	  function map (data, predicates) {
	    assert.object(data);
	
	    if (isFunction(predicates)) {
	      return mapSimple(data, predicates);
	    }
	
	    assert.object(predicates);
	
	    return mapComplex(data, predicates);
	  }
	
	  function mapSimple (data, predicate) {
	    var result = {};
	
	    Object.keys(data).forEach(function (key) {
	      result[key] = predicate(data[key]);
	    });
	
	    return result;
	  }
	
	  function mapComplex (data, predicates) {
	    var result = {};
	
	    Object.keys(predicates).forEach(function (key) {
	      var predicate = predicates[key];
	
	      if (isFunction(predicate)) {
	        if (not.assigned(data)) {
	          result[key] = !!predicate.m;
	        } else {
	          result[key] = predicate(data[key]);
	        }
	      } else if (object(predicate)) {
	        result[key] = mapComplex(data[key], predicate);
	      }
	    });
	
	    return result;
	  }
	
	  /**
	   * Public function `all`
	   *
	   * Check that all boolean values are true
	   * in an array (returned from `apply`)
	   * or object (returned from `map`).
	   *
	   */
	  function all (data) {
	    if (array(data)) {
	      return testArray(data, false);
	    }
	
	    assert.object(data);
	
	    return testObject(data, false);
	  }
	
	  function testArray (data, result) {
	    var i;
	
	    for (i = 0; i < data.length; i += 1) {
	      if (data[i] === result) {
	        return result;
	      }
	    }
	
	    return !result;
	  }
	
	  function testObject (data, result) {
	    var key, value;
	
	    for (key in data) {
	      if (data.hasOwnProperty(key)) {
	        value = data[key];
	
	        if (object(value) && testObject(value, result) === result) {
	          return result;
	        }
	
	        if (value === result) {
	          return result;
	        }
	      }
	    }
	
	    return !result;
	  }
	
	  /**
	   * Public function `any`
	   *
	   * Check that at least one boolean value is true
	   * in an array (returned from `apply`)
	   * or object (returned from `map`).
	   *
	   */
	  function any (data) {
	    if (array(data)) {
	      return testArray(data, true);
	    }
	
	    assert.object(data);
	
	    return testObject(data, true);
	  }
	
	  function mixin (target, source) {
	    Object.keys(source).forEach(function (key) {
	      target[key] = source[key];
	    });
	
	    return target;
	  }
	
	  /**
	   * Public modifier `assert`.
	   *
	   * Throws if `predicate` returns false.
	   */
	  function assertModifier (predicate, defaultMessage) {
	    return function () {
	      return assertPredicate(predicate, arguments, defaultMessage);
	    };
	  }
	
	  function assertPredicate (predicate, args, defaultMessage) {
	    var argCount = predicate.l || predicate.length;
	    var message = args[argCount];
	    var ErrorType = args[argCount + 1];
	    assertImpl(
	      predicate.apply(null, args),
	      nonEmptyString(message) ? message : defaultMessage,
	      isFunction(ErrorType) ? ErrorType : TypeError
	    );
	    return args[0];
	  }
	
	  function assertImpl (value, message, ErrorType) {
	    if (value) {
	      return value;
	    }
	    throw new (ErrorType || Error)(message || 'Assertion failed');
	  }
	
	  /**
	   * Public modifier `not`.
	   *
	   * Negates `predicate`.
	   */
	  function notModifier (predicate) {
	    var modifiedPredicate = function () {
	      return notImpl(predicate.apply(null, arguments));
	    };
	    modifiedPredicate.l = predicate.length;
	    return modifiedPredicate;
	  }
	
	  function notImpl (value) {
	    return !value;
	  }
	
	  /**
	   * Public modifier `maybe`.
	   *
	   * Returns true if predicate argument is  null or undefined,
	   * otherwise propagates the return value from `predicate`.
	   */
	  function maybeModifier (predicate) {
	    var modifiedPredicate = function () {
	      if (not.assigned(arguments[0])) {
	        return true;
	      }
	
	      return predicate.apply(null, arguments);
	    };
	    modifiedPredicate.l = predicate.length;
	
	    // Hackishly indicate that this is a maybe.xxx predicate.
	    // Without this flag, the alternative would be to iterate
	    // through the maybe predicates or use indexOf to check,
	    // which would be time-consuming.
	    modifiedPredicate.m = true;
	
	    return modifiedPredicate;
	  }
	
	  function maybeImpl (value) {
	    if (assigned(value) === false) {
	      return true;
	    }
	
	    return value;
	  }
	
	  /**
	   * Public modifier `of`.
	   *
	   * Applies the chained predicate to members of the collection.
	   */
	  function ofModifier (target, type, predicate) {
	    var modifiedPredicate = function () {
	      var collection, args;
	
	      collection = arguments[0];
	
	      if (target === 'maybe' && not.assigned(collection)) {
	        return true;
	      }
	
	      if (!type(collection)) {
	        return false;
	      }
	
	      collection = coerceCollection(type, collection);
	      args = slice.call(arguments, 1);
	
	      try {
	        collection.forEach(function (item) {
	          if (
	            (target !== 'maybe' || assigned(item)) &&
	            !predicate.apply(null, [ item ].concat(args))
	          ) {
	            // TODO: Replace with for...of when ES6 is required.
	            throw 0;
	          }
	        });
	      } catch (ignore) {
	        return false;
	      }
	
	      return true;
	    };
	    modifiedPredicate.l = predicate.length;
	    return modifiedPredicate;
	  }
	
	  function coerceCollection (type, collection) {
	    switch (type) {
	      case arrayLike:
	        return slice.call(collection);
	      case object:
	        return Object.keys(collection).map(function (key) {
	          return collection[key];
	        });
	      default:
	        return collection;
	    }
	  }
	
	  function createModifiedPredicates (modifier, object) {
	    return createModifiedFunctions([ modifier, predicates, object ]);
	  }
	
	  function createModifiedFunctions (args) {
	    var modifier, object, functions, result;
	
	    modifier = args.shift();
	    object = args.pop();
	    functions = args.pop();
	
	    result = object || {};
	
	    Object.keys(functions).forEach(function (key) {
	      Object.defineProperty(result, key, {
	        configurable: false,
	        enumerable: true,
	        writable: false,
	        value: modifier.apply(null, args.concat(functions[key], messages[key]))
	      });
	    });
	
	    return result;
	  }
	
	  function createModifiedModifier (modifier, modified) {
	    return createModifiedFunctions([ modifier, modified, null ]);
	  }
	
	  function createOfPredicates (key) {
	    predicates[key].of = createModifiedFunctions(
	      [ ofModifier.bind(null, null), predicates[key], predicates, null ]
	    );
	  }
	
	  function createOfModifiers (base, modifier) {
	    collections.forEach(function (key) {
	      base[key].of = createModifiedModifier(modifier, predicates[key].of);
	    });
	  }
	
	  function createMaybeOfModifiers (key) {
	    maybe[key].of = createModifiedFunctions(
	      [ ofModifier.bind(null, 'maybe'), predicates[key], predicates, null ]
	    );
	    assert.maybe[key].of = createModifiedModifier(assertModifier, maybe[key].of);
	    assert.not[key].of = createModifiedModifier(assertModifier, not[key].of);
	  }
	
	  function exportFunctions (functions) {
	    if (true) {
	      !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	        return functions;
	      }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== 'undefined' && module !== null && module.exports) {
	      module.exports = functions;
	    } else {
	      globals.check = functions;
	    }
	  }
	}(this));


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// bam-browser-sdk-sdkSession-util.js